import styled from 'styled-components';
import { Select } from '@material-ui/core';
import { colors } from 'themes';
import { hexWithAlpha } from 'utils';
import { nativePageShell, nativePageScrollRegion } from 'styles/nativePageLayout';

export const PageContainer = styled.div`
  ${nativePageShell}
  background: #fff;
`;

export const MainContent = styled.div`
  ${nativePageScrollRegion}
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 0.5rem 1rem 1rem;
  box-sizing: border-box;

  @media (min-width: 1200px) {
    max-width: 900px;
    padding: 1.5rem 2rem 2rem;
  }

  /* Remove extra padding from MUI Autocomplete only on this page */
  .MuiAutocomplete-root .MuiOutlinedInput-root {
    padding: 0;
  }

  /* Adjust icon padding and input text padding */
  .MuiAutocomplete-root .MuiInputAdornment-root {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2rem; /* equal space on both sides */
    margin: 0; /* remove any default margin */
    padding: 0;
    color: var(--text-secondary);
  }

  /* Enlarge icon */
  .MuiAutocomplete-root .MuiInputAdornment-root svg {
    font-size: 1.25rem;
  }

  .MuiAutocomplete-inputRoot .MuiOutlinedInput-input {
    padding-left: 0 !important;
    font-size: 1rem;
  }

  /* Adjust icon container size on small screens */
  @media (max-width: 418px) {
    .MuiInputAdornment-root {
      width: 1.5rem; /* make icon area narrower */
    }

    .MuiInputAdornment-root svg {
      font-size: 1rem; /* slightly smaller icon */
    }
  }
`;

export const Subtitle = styled.p`
  font-size: var(--typography-body2-size);
  color: var(--text-secondary);
  text-align: center;
  margin: 0.25rem 0 1rem;
`;

export const TimeRow = styled.div`
  display: flex;
  gap: 1rem;
  width: 100%;

  /* Reduce gap on small screens */
  @media (max-width: 418px) {
    gap: 0.5rem;
  }

  /* Stack inputs vertically on very small screens */
  @media (max-width: 520px) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

export const Note = styled.div`
  font-size: var(--typography-body2-size);
  color: var(--text-secondary);
  margin-top: 1.5rem;
  background-color: var(--background-success); /* light blue background */
  padding: 1rem;
  border-radius: var(--borderRadius);
  max-width: 100%;
  box-sizing: border-box;
  border: 1px solid var(--info-main); /* subtle blue border */

  &::before {
    content: "\2022  ";
    color: var(--primary-blue);
    font-weight: bold;
  }
`;

export const FieldLabel = styled.label`
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  display: block;
  color: var(--text-secondary);
`;

export const StyledSelect = styled(Select)`
  width: 100%;
  
  .MuiSelect-select {
    padding: 12px 16px;
    font-size: 18px;
    font-weight: 500;
  }
  
  .MuiOutlinedInput-notchedOutline {
    border-width: 2px;
    border-color: ${hexWithAlpha('#000000', 0.12)};
    border-radius: 12px;
  }
  
  &:hover .MuiOutlinedInput-notchedOutline {
    border-color: ${hexWithAlpha('#000000', 0.2)};
  }
  
  &.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: ${colors.default.primaryBlue};
  }
`; 